import { isAfter, localeAwareFormat, parseISO } from 'app/lib/date';
import type { Listing } from 'app/types/listing';
import { ListingSubtype, TransactionMode } from 'app/types/listing';
import { eachDayOfInterval } from 'date-fns';

interface PerishableOfferDateRangeVisibilityOptions {
  isExistingLoan: boolean;
  isHauteGaspesie: boolean;
  listing?: Pick<Listing, 'end' | 'start' | 'subtype' | 'transactionMode'>;
}

export function shouldShowPerishableOfferDateRange({
  isExistingLoan,
  isHauteGaspesie,
  listing,
}: PerishableOfferDateRangeVisibilityOptions) {
  return Boolean(
    isHauteGaspesie &&
    !isExistingLoan &&
    listing?.subtype === ListingSubtype.expirable &&
    listing.transactionMode === TransactionMode.sell &&
    listing.start &&
    listing.end,
  );
}

export function getPlannedSalePeriodReminderParams(start: string, end: string, dateFormat: string) {
  return {
    start: localeAwareFormat(parseISO(start), dateFormat),
    end: localeAwareFormat(parseISO(end), dateFormat),
  };
}

export function getAccessibleOfferDates(minimumDate?: Date, maximumDate?: Date) {
  if (!minimumDate || !maximumDate || isAfter(minimumDate, maximumDate)) return [];

  return eachDayOfInterval({ start: minimumDate, end: maximumDate });
}
